import { EMI_BANKS_REQUEST, EMI_BANKS_SUCCESS, EMI_BANKS_ERROR } from 'actions/PaymentActions/PaymentActions';
import { LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { EMI_TYPE } from 'pages/PaymentsPage/PaymentOptions/constants';

export const INITIAL_STATE = {};

export default function emiBanks(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case EMI_BANKS_REQUEST:
			return { ...state, asyncStatus: LOADING };
		case EMI_BANKS_SUCCESS:
			let updatedData = removeDuplicateBanks(action.data);
			return { ...state, asyncStatus: SUCCESS, ...updatedData };
		case EMI_BANKS_ERROR:
			return { ...state, asyncStatus: ERROR, error: action.error };
		default:
			return state;
	}
}

/**
 * ToDo: Remove this hack post BBD.
 *
 * This is a hack.
 * If the pre-approved section returns multiple instances of HDFC bank,
 * then keep only HDFC Debit EMI, and remove HDFC CDL.
 */
export function removeDuplicateBanks(banksResponse) {
	if (!banksResponse) return {};

	let { emi_banks: emiBanks, ...otherFields } = banksResponse;
	let modifiedSectionsList =
		emiBanks &&
		emiBanks.map(section => {
			/**
			 * Only modify the section if it's pre-approved EMI
			 */
			if (section.section_code === EMI_TYPE.PRE_APPROVED) {
				let { banks, ...otherSectionFields } = section;
				/**
				 * If section::banks is not an array, or if there are 0 or 1 bank(s) in the array,
				 * then section does not need to be modified.
				 */
				if (!Array.isArray(banks) || banks.length <= 1) return section;

				let hdfcDebitEmiBank = banks.find(bank => {
					return bank.bank_code && bank.bank_code === 'HDFC' && bank.emi_type && bank.emi_type === 'debit-card';
				});

				let hdfcCdlBank = banks.find(bank => {
					return bank.bank_code && bank.bank_code === 'HDFC' && bank.emi_type && bank.emi_type === 'consumer-loan';
				});

				/**
				 * If multiple instances of HDFC bank are not present,
				 * the section does not need to be modified
				 */
				if (!(hdfcCdlBank && hdfcDebitEmiBank)) return section;

				/**
				 * This piece of code will only be triggered if both
				 * HDFC Debit EMI and HDFC CDL are present.
				 *
				 * In this case, we check if HDFC Debit EMI is applicable.
				 * If yes, we simply skip HDFC CDL. If not, then we skip
				 * HDFC Debit EMI, and include HDFC CDL.
				 */
				let isHdfcDebitEmiBankApplicable = !hdfcDebitEmiBank.offer_warning;
				let skipEmiType = isHdfcDebitEmiBankApplicable ? 'consumer-loan' : 'debit-card';
				let finalBanksList = banks.filter(bank => {
					return !(bank.bank_code === 'HDFC' && bank.emi_type && bank.emi_type === skipEmiType);
				});

				return Object.assign({}, otherSectionFields, {
					banks: finalBanksList
				});
			}
			return section;
		});
	return Object.assign({}, otherFields, {
		emi_banks: modifiedSectionsList
	});
}
